import { render, staticRenderFns } from "./cityPartner.vue?vue&type=template&id=b2b22908&scoped=true"
import script from "./cityPartner.vue?vue&type=script&lang=js"
export * from "./cityPartner.vue?vue&type=script&lang=js"
import style0 from "./cityPartner.vue?vue&type=style&index=0&id=b2b22908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b22908",
  null
  
)

export default component.exports